/**
 * @generated SignedSource<<30f497afe611fd75ead3d2b21f2f6575>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamSettingsAdminTeamCalendar_team$data = {
  readonly id: string;
  readonly teamId: string;
  readonly teamName: string;
  readonly teamCalendarId: string | null;
  readonly teamMembers: ReadonlyArray<{
    readonly person: {
      readonly __typename: string;
      readonly id: string;
      readonly userId: string | null;
      readonly personId: string;
      readonly primaryCalendarId: string;
      readonly isYou: boolean;
      readonly profile: {
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
      } | null;
    };
  }>;
  readonly " $fragmentType": "TeamSettingsAdminTeamCalendar_team";
};
export type TeamSettingsAdminTeamCalendar_team$key = {
  readonly " $data"?: TeamSettingsAdminTeamCalendar_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamSettingsAdminTeamCalendar_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamSettingsAdminTeamCalendar_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamCalendarId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMembers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgPerson",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryCalendarId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isYou",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "givenName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "familyName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalImageUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "a1f2d0b81b8a03c8a872fc3e485161f5";

export default node;
